import styled from 'styled-components'

interface StepFourTitleLayoutDesktopProps {
  title: string
}

const StepFourTitleLayoutDesktop = ({
  title,
}: StepFourTitleLayoutDesktopProps) => {
  return (
    <StyledWrapper>
      <strong className="step-title">{title}</strong>
      <p>*제출 후 수정이 불가 합니다.</p>
    </StyledWrapper>
  )
}

export default StepFourTitleLayoutDesktop

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 40px;

  > .step-title {
    white-space: pre;
    font-size: 32px;
    font-weight: bold;
    line-height: 1.25;
    letter-spacing: -1.28px;
    text-align: center;
    color: #333;
    font-family: 'GmarketSansMedium';
  }

  > p {
    font-size: 16px;
    font-weight: normal;
    letter-spacing: -0.64px;
    text-align: center;
    color: #333;
  }
`
